import type { ExportColumn } from '@app/src/types/export'
import { Solutions } from '../wf-constants'
import { getProviderExportColumns } from './provider'
import { getResponseExportColumns } from './response'
import { getProductExportColumns } from '@app/src/export-columns/product'

const COMPANY_EXPORT_PATH = 'response.request.subscriptions[0].target'

export const getResponseItemExportColumnsAccessor = (
  solution?: string,
  includeTargetProduct?: boolean,
  includeOrganizationId?: boolean,
): ExportColumn[] => {
  const columns: ExportColumn[] = [
    {
      translationId: 'general.id',
      exportPath: 'id',
    },
    {
      translationId: 'schemas.responseItem.requestItemTemplateId',
      exportPath: 'requestItem.questionId',
    },
    {
      translationId: 'schemas.responseItem.object',
      exportPath: 'requestItem.description',
    },
    {
      translationId: 'schemas.responseItem.section',
      exportPath: 'requestItem.section.title',
    },
    {
      translationId: 'schemas.responseItem.answer',
      exportPath: 'answer',
    },
    {
      translationId: 'schemas.responseItem.comment',
      exportPath: 'comment',
    },
    {
      translationId: 'schemas.responseItem.unit',
      exportPath: 'requestItem.unit.symbol',
    },
    {
      translationId: 'schemas.responseItem.externalVerificationStatus',
      exportPath: 'verifications[0].externalVerificationStatus',
    },
    {
      translationId: 'schemas.responseItem.internalVerificationStatus',
      exportPath: 'verifications[0].internalVerificationStatus',
    },
    {
      translationId: 'schemas.responseItem.externalVerificationComment',
      exportPath: 'verifications[0].externalVerificationComment',
    },
    {
      translationId: 'schemas.responseItem.internalVerificationComment',
      exportPath: 'verifications[0].internalVerificationComment',
    },
    {
      translationId: 'schemas.responseItem.request',
      exportPath: 'response.request.title',
    },
    {
      translationId: 'schemas.responseItem.periodDisplayName',
      exportPath: 'response.request.periodName',
    },
    {
      translationId: 'schemas.responseItem.periodStartsAt',
      exportPath: 'requestItem.PeriodStartsAt',
    },
    {
      translationId: 'schemas.responseItem.periodEndsAt',
      exportPath: 'requestItem.PeriodEndsAt',
    },
    {
      translationId: 'schemas.responseItem.questionType',
      exportPath: 'requestItem.QuestionType.name',
    },
    {
      translationId: 'schemas.responseItem.hasAnswered',
      exportPath: 'isAnswered',
    },
    {
      translationId: 'schemas.responseItem.expiresAt',
      exportPath: 'expiresAt',
    },
    {
      translationId: 'export.schemas.response.yourFlag',
      exportPath: 'yourflag',
    },
    {
      translationId: 'export.schemas.response.worldfavorFlag',
      exportPath: 'suggestedrisk',
    },
    ...getResponseExportColumns('response'),
    ...getProviderExportColumns(solution, COMPANY_EXPORT_PATH, ['ownerUsers'], includeOrganizationId),
    ...(includeTargetProduct ? getProductExportColumns('response.request.targetProduct', includeOrganizationId) : []),
  ]

  if (solution === Solutions.Investment) {
    const index = columns.findIndex(entry => entry.exportPath === `${COMPANY_EXPORT_PATH}.name`)
    if (index > -1) {
      const [item] = columns.splice(index, 1)
      columns.unshift(item)
    }
  }

  return columns
}
